import React, { useEffect, useState } from "react";

// components
import ProgramCard from "../ProgramCard";
import { CenterPlusCard, HomeTrainingCard, RecommendCard } from "./Cards";

// utils
import { api } from "bodycodi/cmap/app/js/api";

const ProgramDetail = ({ details, setRefetch }: any) => {
  const [coachRecommendList, setCoachRecommendList] = useState<Array<any>>([]);
  const [centerPlusList, setCenterPlusList] = useState<Array<any>>([]);
  const [homeTrainingList, setHomeTrainingList] = useState<Array<any>>([]);

  const fetchProgramDetail = async () => {
    try {
      await api.get(`/plus/programs/details/${details?.seqPlusProgram}`).then(({ data }) => {
        setCoachRecommendList(data.productGoods);
        setCenterPlusList(data.productCenters);
        setHomeTrainingList(data.productVideos);
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchProgramDetail();
  }, []);

  return (
    <div className="popup-body no-padding">
      <div className="program-detail">
        <ProgramCard type="detail" setRefetch={setRefetch} {...details} />

        <hr />

        {!!coachRecommendList?.length && (
          <div className="section">
            <span className="header">강사 추천</span>
            {coachRecommendList?.map((item: any) => {
              return <RecommendCard key={item?.seqPlusProduct} details={item} />;
            })}
            <hr />
          </div>
        )}

        {!!centerPlusList?.length && (
          <div className="section">
            <span className="header">센터+</span>
            {centerPlusList?.map((item: any) => {
              return <CenterPlusCard key={item?.seqPlusProduct} details={item} />;
            })}
            <hr />
          </div>
        )}

        {!!homeTrainingList?.length && (
          <div className="section">
            <span className="header">홈트+</span>
            {homeTrainingList?.map((item: any) => {
              return <HomeTrainingCard key={item?.seqPlusProduct} details={item} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgramDetail;
